export default __webpack_public_path__ + "static/ProviderAccessInterviews-a6588eb2943b17d44f2bb87417223597.svg";